<template>
  <div class="lk-container">
    <h1 class="title">
      Спасибо!
    </h1>
    <h1 class="paragraph">
      Ваши документы подписаны. Ожидайте открытия счета
    </h1>
  </div>
</template>
<script>
import RegFormMixin from "../form_mixin";
export default {
  mixins: [RegFormMixin],
  beforeMount() {
    this.$store.dispatch("getUserSystemStatus").then(res => {
      if (res.data.status) {
        this.$store.commit(
          "setUserSystemStatus",
          res.data.result.system_status
        );
        if (this.systemStatus === 40) {
          this.$router.push({ name: "finance-overview" });
        }
      } else {
        this.$toasted.show("Произошла ошибка: Обновите страницу");
      }
    });
  }
};
</script>

<style scoped>
.lk-container {
  color: #ffffff;
}

.title {
  text-align: center;
}

.paragraph {
  margin-top: 30px;
  font-size: 20px;
  text-align: center;
}
</style>
